// import JS files
import { h, render } from 'preact';
import Embed from './embed';
import { frameLoader } from '../frames';

frameLoader(() => {
  render(<Embed />, document.getElementById('graphic'));
});
